import React from 'react';

const SearchBox = props => {
    const handleFocus = e => {
        props.handleOnFocus();
    };

    const handleBlur = e => {
        props.handleOnBlur();
    };

    const handleChange = e => {
        if (e.target.value) {
            props.handleSetTerm(e.target.value);
            props.handleHasTyped(true);
        } else {
            props.handleSetTerm('');
            props.handleHasTyped(false);
        }
    };

    return (
        <form action="/?s" autoComplete="off" id="search" method="GET" className={`search-form${props.isActive ? ' search-form--active' : ''}`}>
            <input
                type="search"
                id="s"
                name="s"
                value={props.term}
                placeholder="Search e.g. keyword, product"
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            {props.type ? (
            <input
                type="hidden"
                id="type"
                name="type"
                value={props.type}
            /> ) : '' }
            {props.tax ? (
            <input
                type="hidden"
                id="tax"
                name="tax"
                value={props.tax}
            /> ) : '' }
            {props.term ? (
                <i
                    className="icon-close"
                    onClick={() => {
                        props.handleCloseOverlay();
                    }}
                />
            ) : (
                <i className="icon-search"></i>
            )}
            <label htmlFor="s" />
        </form>
    );
};

export default SearchBox;
